
import Vue from 'vue'
import {
  Cell,
  Button,
  NavBar,
  Toast,
  Tab,
  Tabs,
  NumberKeyboard,
  Field,
  Uploader,
  Sticky,
  Dialog,
  Form,
  Stepper,
  Icon,
  PasswordInput,
  List,
  Row,
  Col,
  Tag,
  Divider,
  CellGroup,
  Image,
  ActionSheet,
  Swipe,
  SwipeItem,
  Tabbar,
  TabbarItem,
  Popup,
  Step,
  Steps,
  PullRefresh
} from 'vant'
Vue.use(Cell)
Vue.use(Button)
Vue.use(NavBar)
Vue.use(Tab)
Vue.use(Tabs)
Vue.use(NumberKeyboard)
Vue.use(Field)
Vue.use(Uploader)
Vue.use(Sticky)
Vue.use(Dialog)
Vue.use(Form)
Vue.use(Stepper)
Vue.use(Icon)
Vue.use(PasswordInput)
Vue.use(List)
Vue.use(Row)
Vue.use(Col)
Vue.use(Tag)
Vue.use(Divider)
Vue.use(CellGroup)
Vue.use(Image)
Vue.use(ActionSheet)
// Vue.use(Toast)
Vue.use(Swipe)
Vue.use(SwipeItem)
Vue.use(Tabbar)
Vue.use(TabbarItem)
Vue.use(Popup)
Vue.use(Step)
Vue.use(Steps)
Vue.use(PullRefresh)
Vue.prototype.Toast = Toast
// Vue.prototype.Dialog = Dialog
